import React from 'react';
import { Table } from 'antd';
import { Eye, Layers } from 'lucide-react';
import { SectionCard, StatusTag, IconAction, IconActions, EmptyState } from '../../common';
import SegmentTableActions from './SegmentTableActions';

export default function StoreTypeTable({ storeTypes, rows, search, suggestions, onSearch, onSearchChange, navigateSegmentList }) {
    const StoreTypeColumns = [
        {
            title: 'Segmentación',
            dataIndex: 'label',
            key: 'label',
            render: (text, record) => (
                <div className="flex items-center gap-3">
                    <span
                        className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-[15px] ${
                            record.channel === 'moderno' ? 'bg-primary-50 text-primary-600' : 'bg-warning-bg text-warning-fg'
                        }`}>
                        <Layers />
                    </span>
                    <div className="min-w-0">
                        <div className="text-sm font-medium text-surface-900 truncate">{text}</div>
                        <div className="text-xs text-surface-500">Tipo de piso de venta</div>
                    </div>
                </div>
            ),
            sorter: (a, b) => a.label.localeCompare(b.label)
        },
        {
            title: 'Canal',
            dataIndex: 'channel',
            key: 'channel',
            render: (text) => <StatusTag tone={text === 'moderno' ? 'brand' : 'warning'}>{text === 'moderno' ? 'Moderno' : 'Tradicional'}</StatusTag>,
            filters: [
                { text: 'Moderno', value: 'moderno' },
                { text: 'Tradicional', value: 'tradicional' }
            ],
            onFilter: (value, record) => record.channel === value
        },
        {
            title: 'Productos',
            dataIndex: 'products',
            key: 'products',
            align: 'right',
            render: (products) => (
                <span className="text-sm tabular-nums text-surface-900">
                    {products?.length || 0} <span className="text-surface-500">productos</span>
                </span>
            ),
            sorter: (a, b) => (a.products?.length || 0) - (b.products?.length || 0)
        },
        {
            title: 'Estado',
            dataIndex: 'active',
            key: 'active',
            align: 'center',
            render: (active) => (
                <StatusTag tone={active ? 'success' : 'danger'} dot>
                    {active ? 'Activo' : 'Inactivo'}
                </StatusTag>
            ),
            filters: [
                { text: 'Activo', value: true },
                { text: 'Inactivo', value: false }
            ],
            onFilter: (value, record) => record.active === value
        },
        {
            title: 'Acciones',
            key: 'actions',
            align: 'right',
            width: 96,
            render: (_, record) => (
                <IconActions>
                    <IconAction
                        icon={<Eye />}
                        label="Ver Productos"
                        onClick={() => navigateSegmentList(storeTypes?.find((store) => store.label === record.label)?.value)}
                    />
                </IconActions>
            )
        }
    ];

    return (
        <SectionCard
            flush
            title="Segmentaciones"
            description="Tipos de piso de venta y los productos que se auditan en cada uno">
            <div className="px-5 py-3 border-b border-surface-100">
                <SegmentTableActions search={search} suggestions={suggestions} onSearch={onSearch} onSearchChange={onSearchChange} />
            </div>
            <div className="overflow-x-auto">
                <Table
                    dataSource={rows}
                    columns={StoreTypeColumns}
                    pagination={{
                        pageSize: 20,
                        showSizeChanger: true,
                        showTotal: (total) => `Total ${total} segmentaciones`
                    }}
                    rowKey="value"
                    size="middle"
                    locale={{
                        emptyText: <EmptyState icon={<Layers />} title="Sin segmentaciones" description="No hay segmentaciones que coincidan con la búsqueda" />
                    }}
                />
            </div>
        </SectionCard>
    );
}
